module.exports = __webpack_public_path__ + "static/media/Supporter.166ecb7b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/Supporter.png
 ** module id = 365
 ** module chunks = 0
 **/